import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { FiUserCheck } from 'react-icons/fi';
import { Modal, Form, Table } from 'react-bootstrap';
// import { studentData } from '../data/studentData'; // Removed, data will be fetched from CSV
import PillButton from './PillButton'; // Reuse the existing PillButton

const SHOW_TESTER_BUTTON = false;

const FloatingWrapper = styled.div`
  position: fixed;
  top: 162px;
  right: 25px;
  z-index: 1050;
  
  @media (max-width: 768px) {
    top: 152px;
    right: 20px;
  }
`;

const FloatingBtn = styled.button`
  width: 50px;
  height: 50px;
  border-radius: 25px;
  background: linear-gradient(90deg, #6a11cb 0%, #2575fc 100%);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  transition: all 0.35s ease-in-out;
  overflow: hidden;
  white-space: nowrap;
  border: none;
  cursor: pointer;
  padding: 0;

  .icon {
    font-size: 24px;
    flex-shrink: 0;
    transition: all 0.35s ease-in-out;
    margin-left: 8px; /* Nudge right for visual centering */
  }

  .text {
    font-size: 16px;
    font-weight: 600;
    opacity: 0;
    max-width: 0;
    margin-left: 0;
    transition: opacity 0.2s ease-in-out, max-width 0.3s ease-in-out, margin-left 0.3s ease-in-out;
  }

  &:hover {
    width: 250px;
    transform: translateY(-2px);
    box-shadow: 0 6px 18px rgba(0, 0, 0, 0.3);

    .icon {
        margin-left: 0;
    }

    .text {
      opacity: 1;
      max-width: 200px;
      margin-left: 10px;
    }
  }

  @media (max-width: 768px) {
    width: 45px;
    height: 45px;
    border-radius: 22.5px;

    .icon {
      font-size: 22px;
      margin-left: 7px; /* Nudge right for visual centering */
    }
    
    &:hover {
      width: 230px;
      
      .icon {
        margin-left: 0;
      }
    }
  }
`;

// Custom styled Modal to override Bootstrap defaults
const StyledModal = styled(Modal)`
  .modal-content {
    background-color: var(--secondary-color);
    color: var(--text-color);
    border: 1px solid rgba(255, 255, 255, 0.1);
    box-shadow: 0 0 20px rgba(0, 0, 0, 0.5);
  }

  .modal-header {
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
    
    .btn-close {
      filter: invert(1) grayscale(100%) brightness(200%);
    }
  }

  .modal-footer {
    border-top: 1px solid rgba(255, 255, 255, 0.1);
  }
`;

const StyledTable = styled(Table)`
  color: var(--text-color) !important;
  
  th, td {
    border-color: rgba(255, 255, 255, 0.1) !important;
    background-color: transparent !important;
    color: var(--text-color) !important;
    vertical-align: middle;
  }
  
  thead th {
    border-bottom: 2px solid var(--accent-color-1);
    color: var(--accent-color-2) !important;
  }
`;

const CheckStatus = () => {
  const [show, setShow] = useState(false);
  const [parentName, setParentName] = useState('');
  const [parentPhone, setParentPhone] = useState('');
  const [results, setResults] = useState([]);
  const [searched, setSearched] = useState(false);
  const [studentCsvData, setStudentCsvData] = useState([]);

  useEffect(() => {
    const fetchStudentData = async () => {
      try {
        // console.log("Fetching student data from CSV...");
        // Use process.env.PUBLIC_URL to ensure correct path
        const response = await fetch(process.env.PUBLIC_URL + '/testers_list.csv');
        
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        
        const text = await response.text();
        // console.log("CSV loaded, length:", text.length);

        const lines = text.split('\n').filter(line => line.trim() !== ''); 
        
        if (lines.length === 0) {
            console.warn("CSV file is empty");
            return;
        }

        const headers = lines[0].split(',').map(header => header.trim());
        // console.log("CSV Headers:", headers);

        const data = lines.slice(1).map(line => {
          const values = line.split(',');
          
          const getVal = (key) => {
              const index = headers.indexOf(key);
              // Safely access value and trim whitespace
              return index !== -1 && values[index] ? values[index].trim() : '';
          };

          return {
            parentName: getVal('학부모 성함'),
            parentPhone: getVal('학부모 연락처'),
            studentName: getVal('자녀 이름'),
            account: getVal('계정'),
            password: getVal('비밀번호')
          };
        });
        
        // console.log("Parsed student data count:", data.length);
        if (data.length > 0) {
             // console.log("First row sample:", data[0]);
        }
        setStudentCsvData(data);
      } catch (error) {
        console.error("Failed to fetch student data:", error);
      }
    };

    fetchStudentData();
  }, []);

  const handleClose = () => {
    setShow(false);
    setParentName('');
    setParentPhone('');
    setResults([]);
    setSearched(false);
  };
  const handleShow = () => setShow(true);

  const normalizePhone = (phone) => phone.replace(/[^0-9]/g, '');

  const handleSearch = (e) => {
    e.preventDefault();
    if (!parentName || !parentPhone) {
      alert('성함과 연락처를 모두 입력해주세요.');
      return;
    }

    const inputPhone = normalizePhone(parentPhone);
    
    const foundStudents = studentCsvData.filter(student => {
        const dataPhone = normalizePhone(student.parentPhone);
        return student.parentName.trim() === parentName.trim() && dataPhone === inputPhone;
    });

    setResults(foundStudents);
    setSearched(true);
  };

  return (
    <>
      {SHOW_TESTER_BUTTON && (
        <FloatingWrapper>
          <FloatingBtn onClick={handleShow} aria-label="테스터 계정 확인하기">
            <FiUserCheck className="icon" />
            <span className="text">테스터 계정 확인하기</span>
          </FloatingBtn>
        </FloatingWrapper>
      )}

      <StyledModal show={show} onHide={handleClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>입단 테스트용 계정 확인</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleSearch}>
            <Form.Group className="mb-3" controlId="formParentName">
              <Form.Label>학부모 성함</Form.Label>
              <Form.Control 
                type="text" 
                placeholder="예: 홍길동" 
                value={parentName}
                onChange={(e) => setParentName(e.target.value)}
                autoComplete="off"
              />
            </Form.Group>

            <Form.Group className="mb-4" controlId="formParentPhone">
              <Form.Label>학부모 연락처</Form.Label>
              <Form.Control 
                type="text" 
                placeholder="예: 010-1234-5678 또는 01012345678" 
                value={parentPhone}
                onChange={(e) => setParentPhone(e.target.value)}
                autoComplete="off"
              />
              <Form.Text className="text-muted mt-2">
                해외 번호는 국가번호부터 입력해주세요. (+ 기호 생략 가능)
              </Form.Text>
            </Form.Group>
            
            <div className="d-grid gap-2">
              <PillButton type="submit">
                조회하기
              </PillButton>
            </div>
          </Form>

          {searched && (
            <div className="mt-4">
              {results.length > 0 ? (
                <>
                  <h6 className="mb-3" style={{color: 'var(--accent-color-2)'}}>조회 결과 ({results.length}명)</h6>
                  <StyledTable responsive>
                    <thead>
                      <tr>
                        <th>자녀 이름</th>
                        <th>계정 (ID)</th>
                        <th>비밀번호</th>
                      </tr>
                    </thead>
                    <tbody>
                      {results.map((student, index) => (
                        <tr key={index}>
                          <td>{student.studentName}</td>
                          <td>{student.account}</td>
                          <td>{student.password}</td>
                        </tr>
                      ))}
                    </tbody>
                  </StyledTable>
                  <div className="mt-4 p-3 rounded" style={{backgroundColor: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.1)'}}>
                    <h6 className="mb-3" style={{color: 'var(--accent-color-1)', fontSize: '1.25rem', fontWeight: '700'}}>💡 입단 테스트 진행 가이드</h6>
                    <p className="text-white mb-1"><strong>1. 접속 및 학습 방법</strong></p>
                    <ul className="list-unstyled text-white-50 ms-3 mb-3">
                      <li>- 홈페이지 우측 상단 [서비스 바로가기] → narnia web-terminal 로그인</li>
                      <li>- 배정된 계정으로 접속 후, 전체 튜토리얼 4개 중 2개(나니아 기본 사용법, AI로 미니게임 만들기)을 수행하도록 지도해 주세요.</li>
                    </ul>

                    <p className="text-white mb-1"><strong>2. 이용 시간 (Time Limit)</strong></p>
                    <ul className="list-unstyled text-white-50 ms-3 mb-3">
                      <li>- 계정 이용 시간은 총 1시간입니다.</li>
                      <li>- 접속을 끊으면 시간 차감도 멈추니 안심하세요.</li>
                    </ul>

                    <p className="text-white mb-1"><strong>3. 주의 사항 (필독)</strong></p>
                    <ul className="list-unstyled text-white-50 ms-3 mb-0">
                      <li>✅ 파일 삭제 금지: 튜토리얼 완료 시 생성되는 파일로 시스템이 이수 여부를 확인합니다. 해당 파일을 지우지 않도록 주의 부탁드립니다.</li>
                    </ul>
                  </div>
                </>
              ) : (
                <div className="alert alert-dark text-center" role="alert" style={{backgroundColor: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.1)', color: 'var(--text-color-darker)'}}>
                  일치하는 정보가 없습니다.<br/>
                  성함과 연락처를 다시 확인해주세요.
                </div>
              )}
            </div>
          )}
        </Modal.Body>
      </StyledModal>
    </>
  );
};

export default CheckStatus;
